// extracted by mini-css-extract-plugin
export default {"widthContainer":"zH2SLl","image":"Ivhtfq"};